module.exports = __webpack_public_path__ + "static/img/order-question.3845681f.svg";